import {
    AppFlow,
    InitialState,
} from 'Container/App/interface';
import { AdditionalPageOptions } from '../../../interface';
import {
    getCustomerFlow,
    getFlowType,
    getSiteStructure,
    PageViewTrackingData,
    PageViewTrackingDataWithError,
    TRACKING_PLATFORM_TYPE_RESPONSIVE,
    TRACKING_SITE_AREA_MOBILITY,
    TrackingBtx,
    TrackingError,
    TrackingLoginStatus,
    TrackingPageType,
} from '@vfde-sails/tracking';
import {
    BTX_BNT,
    BTX_VVL,
    FLOW_SUBSCRIPTIONS_FIRST,
    SALESCHANNEL_REDPLUS,
} from '@vfde-sails/constants';

/**
 * Create the page view tracking object
 */
export const createPageViewTrackingData = (trackingData: {
    flow: InitialState['customerConfig']['flow'],
    salesChannel: InitialState['customerConfig']['salesChannel'],
    pageName: AdditionalPageOptions['pageName'],
}) => {
    const pageLevels = getSiteStructure(trackingData.pageName, BTX_BNT);
    const loginStatus = trackingData.flow === AppFlow.Vvl ? TrackingLoginStatus.LoggedIn : TrackingLoginStatus.NotLoggedIn;
    const lineOfCustomer = getCustomerFlow(trackingData.salesChannel);
    const pageType = TrackingPageType.ProductListing;
    const businessTransactionType = trackingData.flow === AppFlow.Vvl ? TrackingBtx.Vvl : TrackingBtx.Bnt;
    const flowType = getFlowType(
        FLOW_SUBSCRIPTIONS_FIRST,
        SALESCHANNEL_REDPLUS,
        trackingData.flow === AppFlow.Vvl ? BTX_VVL : BTX_BNT,
    );

    const pageViewTrackingData: PageViewTrackingData = {
        /* eslint-disable jsdoc/require-jsdoc, @typescript-eslint/naming-convention, camelcase */
        page_levels: pageLevels,
        page_type: pageType,
        login_status: loginStatus,
        site_area: TRACKING_SITE_AREA_MOBILITY,
        platform_type: TRACKING_PLATFORM_TYPE_RESPONSIVE,
        flow_type: flowType,
        business_transaction_type: businessTransactionType,
        line_of_customer: lineOfCustomer,
        /* eslint-enable jsdoc/require-jsdoc, @typescript-eslint/naming-convention, camelcase */
    };

    return pageViewTrackingData;
};

/**
 * Create the page view tracking object with error
 */
export const createPageViewTrackingDataWithError = (
    trackingData: Parameters<typeof createPageViewTrackingData>[0],
    trackingError: TrackingError,
): PageViewTrackingDataWithError => {
    const pageViewTrackingData = createPageViewTrackingData(trackingData);

    return {
        ...pageViewTrackingData,
        ...trackingError,
    };
};
